export default {
  chatFlows: [],
  chatFlowInfos: null
}
